import apiUrl from "../../../../utils/settings";

export const getNetworkFilterURL = () => {
    return apiUrl + '/my-network/v1/filters';
}
export const getNetworkListURL = () => {
    return apiUrl + '/my-network/v1/network-list';
}
export const getNetworkPerformanceURL = () => {
    return apiUrl + '/my-network/v1/network-info/performance';
}
export const getNetworkRewardURL = () => {
    return apiUrl + '/my-network/v1/network-info/rewards';
}
export const getNetworkSummaryURL = () => {
    return apiUrl + '/my-network/v1/summary';
}